/* Panneau de recherche : ouverture depuis la loupe du header, suggestions
   instantanées (API Predictive Search + section recherche-predictive),
   dernières recherches en localStorage, navigation clavier (combobox). */
(function () {
  var d = document.documentElement;
  var rp = document.querySelector('[data-rp]');
  if (!rp) return;

  var voile = document.querySelector('[data-rp-voile]');
  var form = rp.querySelector('[data-rp-form]');
  var input = rp.querySelector('[data-rp-input]');
  var vider = rp.querySelector('[data-rp-vider]');
  var fermerBtn = rp.querySelector('[data-rp-close]');
  var vide = rp.querySelector('[data-rp-vide]');
  var resultats = rp.querySelector('[data-rp-resultats]');
  var urlPredictive = rp.getAttribute('data-url-predictive') || '/search/suggest';
  var urlSearch = rp.getAttribute('data-url-search') || '/search';
  var sectionId = rp.getAttribute('data-section') || 'recherche-predictive';

  var CLE = 'sm_recherches';
  var MAX_RECENTES = 6;
  var DELAI = 300;
  var MIN = 2;

  var ouvert = false;
  var retourFocus = null;
  var timer = null;
  var controleur = null;
  var derniereRequete = '';
  var actif = -1;

  /* ===== Dernières recherches ===== */
  function lireRecentes() {
    try {
      var l = JSON.parse(localStorage.getItem(CLE) || '[]');
      return Array.isArray(l) ? l : [];
    } catch (e) { return []; }
  }
  function ecrireRecentes(liste) {
    try { localStorage.setItem(CLE, JSON.stringify(liste.slice(0, MAX_RECENTES))); } catch (e) {}
  }
  function memoriser(terme) {
    terme = (terme || '').trim();
    if (!terme) return;
    var bas = terme.toLowerCase();
    var liste = lireRecentes().filter(function (t) { return String(t).toLowerCase() !== bas; });
    liste.unshift(terme);
    ecrireRecentes(liste);
  }
  function rendreRecentes() {
    var bloc = rp.querySelector('[data-rs-recentes]');
    var liste = rp.querySelector('[data-rs-recentes-liste]');
    if (!bloc || !liste) return;
    var recentes = lireRecentes();
    bloc.hidden = recentes.length === 0;
    liste.innerHTML = '';
    recentes.forEach(function (t) {
      var a = document.createElement('a');
      a.className = 'rs-chip rs-chip-recente';
      a.href = urlSearch + '?q=' + encodeURIComponent(t) + '&type=product';
      a.setAttribute('data-option', '');
      a.setAttribute('data-terme', t);
      a.textContent = t;
      liste.appendChild(a);
    });
  }
  var effacer = rp.querySelector('[data-rs-effacer]');
  if (effacer) {
    effacer.addEventListener('click', function () {
      try { localStorage.removeItem(CLE); } catch (e) {}
      rendreRecentes();
      input.focus();
    });
  }

  /* la page de résultats mémorise le terme cherché */
  try {
    if (location.pathname.replace(/\/$/, '') === urlSearch.replace(/\/$/, '')) {
      var q = new URLSearchParams(location.search).get('q');
      if (q) memoriser(q);
    }
  } catch (e) {}

  /* ===== Ouverture / fermeture ===== */
  function ouvrir() {
    if (ouvert) return;
    ouvert = true;
    retourFocus = document.activeElement;
    if (window.Panier && window.Panier.fermer) window.Panier.fermer();
    rp.classList.add('on');
    if (voile) voile.classList.add('on');
    d.classList.add('recherche-open');
    rendreRecentes();
    majVider();
    /* le focus après le début de la transition : sinon iOS n'ouvre pas le clavier */
    setTimeout(function () {
      input.focus();
      input.select();
    }, 40);
  }
  function fermer() {
    if (!ouvert) return;
    ouvert = false;
    rp.classList.remove('on');
    if (voile) voile.classList.remove('on');
    d.classList.remove('recherche-open');
    annulerRequete();
    desactiver();
    if (retourFocus && retourFocus.focus) retourFocus.focus();
  }
  window.Recherche = { ouvrir: ouvrir, fermer: fermer };

  /* la loupe du header ouvre le panneau au lieu de naviguer */
  Array.prototype.forEach.call(document.querySelectorAll('[data-recherche-ouvrir]'), function (el) {
    el.setAttribute('aria-haspopup', 'dialog');
    el.setAttribute('aria-controls', 'recherche-panneau');
    el.addEventListener('click', function (e) {
      e.preventDefault();
      ouvrir();
    });
  });

  if (fermerBtn) fermerBtn.addEventListener('click', fermer);
  if (voile) voile.addEventListener('click', fermer);

  /* ===== Champ ===== */
  function majVider() {
    if (vider) vider.hidden = input.value.length === 0;
  }
  if (vider) {
    vider.addEventListener('click', function () {
      input.value = '';
      majVider();
      montrerVide();
      input.focus();
    });
  }

  function montrerVide() {
    annulerRequete();
    derniereRequete = '';
    desactiver();
    resultats.hidden = true;
    resultats.innerHTML = '';
    vide.hidden = false;
    input.setAttribute('aria-expanded', 'false');
  }
  function montrerResultats() {
    desactiver();
    vide.hidden = true;
    resultats.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    rp.querySelector('.rp-corps').scrollTop = 0;
  }

  function annulerRequete() {
    clearTimeout(timer);
    if (controleur) {
      controleur.abort();
      controleur = null;
    }
    rp.classList.remove('charge');
  }

  function chercher(terme) {
    if (terme === derniereRequete) return;
    derniereRequete = terme;
    if (controleur) controleur.abort();
    controleur = ('AbortController' in window) ? new AbortController() : null;
    rp.classList.add('charge');
    var url = urlPredictive +
      '?q=' + encodeURIComponent(terme) +
      '&resources[type]=product' +
      '&resources[limit]=8' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag' +
      '&section_id=' + encodeURIComponent(sectionId);
    fetch(url, controleur ? { signal: controleur.signal } : undefined)
      .then(function (r) {
        if (!r.ok) throw new Error('predictive ' + r.status);
        return r.text();
      })
      .then(function (html) {
        if (terme !== derniereRequete) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var contenu = doc.querySelector('[data-rr]');
        resultats.innerHTML = '';
        if (contenu) {
          resultats.appendChild(contenu);
          montrerResultats();
        }
      })
      .catch(function (e) {
        /* requête annulée ou API indisponible : on garde l'état précédent,
           Entrée mène toujours à la page de résultats */
        if (e && e.name === 'AbortError') return;
      })
      .finally(function () {
        if (terme === derniereRequete) rp.classList.remove('charge');
      });
  }

  input.addEventListener('input', function () {
    majVider();
    clearTimeout(timer);
    var terme = input.value.trim();
    if (terme.length < MIN) {
      montrerVide();
      return;
    }
    timer = setTimeout(function () { chercher(terme); }, DELAI);
  });

  form.addEventListener('submit', function (e) {
    var terme = input.value.trim();
    if (!terme) {
      e.preventDefault();
      input.focus();
      return;
    }
    memoriser(terme);
  });

  /* clics sur les liens du panneau : mémoriser le terme s'il y en a un */
  rp.addEventListener('click', function (e) {
    var lien = e.target.closest('[data-option]');
    if (!lien) return;
    var terme = lien.getAttribute('data-terme');
    if (terme) memoriser(terme);
  });

  /* ===== Clavier : flèches, Entrée, Échap, piège de tabulation ===== */
  function options() {
    return Array.prototype.filter.call(rp.querySelectorAll('[data-option]'), function (el) {
      return el.offsetParent !== null;
    });
  }
  function desactiver() {
    if (actif < 0) return;
    Array.prototype.forEach.call(rp.querySelectorAll('.est-actif'), function (el) {
      el.classList.remove('est-actif');
      el.removeAttribute('aria-selected');
    });
    input.removeAttribute('aria-activedescendant');
    actif = -1;
  }
  function activer(index) {
    var liste = options();
    if (!liste.length) return;
    desactiver();
    if (index < 0) index = liste.length - 1;
    if (index >= liste.length) index = 0;
    actif = index;
    var el = liste[index];
    el.classList.add('est-actif');
    el.setAttribute('aria-selected', 'true');
    if (!el.id) el.id = 'rp-opt-' + index;
    input.setAttribute('aria-activedescendant', el.id);
    if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
  }

  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activer(actif + 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      activer(actif - 1);
    } else if (e.key === 'Enter' && actif >= 0) {
      var liste = options();
      var el = liste[actif];
      if (el && el.href) {
        e.preventDefault();
        var terme = el.getAttribute('data-terme');
        if (terme) memoriser(terme);
        location.href = el.href;
      }
    } else if (e.key === 'Home' || e.key === 'End') {
      /* laisse le curseur bouger dans le champ */
      desactiver();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!ouvert) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      fermer();
      return;
    }
    if (e.key === 'Tab') {
      var focusables = Array.prototype.filter.call(
        rp.querySelectorAll('a[href], button:not([hidden]), input, [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!focusables.length) return;
      var premier = focusables[0];
      var dernier = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === premier) {
        e.preventDefault();
        dernier.focus();
      } else if (!e.shiftKey && document.activeElement === dernier) {
        e.preventDefault();
        premier.focus();
      }
    }
  });

  /* raccourci : « / » hors d'un champ ouvre la recherche */
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || ouvert) return;
    var t = e.target;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
    e.preventDefault();
    ouvrir();
  });
})();
